import { randomElement } from '@/utils';

const BOSS_NAME_PREFIXES: readonly string[] = [
  'Bezlitosny',
  'Bogini',
  'Bóg',
  'Cesarz',
  'Cesarzowa',
  'Cień',
  'Ciotka',
  'Dominator',
  'Essa',
  'Gniew',
  'Imperator',
  'Imperatorka',
  'Janusz',
  'Kapłan',
  'Kieł',
  'Król',
  'Królowa',
  'Krwawy',
  'Krzyk',
  'Krzykaczka',
  'Książę',
  'Księżniczka',
  'Łowca',
  'Marcel',
  'Matka',
  'Miłośnik',
  'Mroczny',
  'Nadzorca',
  'Niszczyciel',
  'Obrońca',
  'Ojciec',
  'Opus',
  'Pan',
  'Płacz',
  'Pogromca',
  'Potężny',
  'Powrót',
  'Pożeracz',
  'Rzeźniczka',
  'Rzeźnik',
  'Sigma',
  'Starożytny',
  'Strach',
  'Strażnik',
  'Szalony',
  'Wdowa',
  'Wielki',
  'Władca',
  'Wujek',
  'Zabójca',
  'Zderzacz',
  'Złoty',
  'Zwiastun',
] as const;

const BOSS_NAME_SUFFIXES: readonly string[] = [
  'Baagera',
  'Beliara',
  'Beredy',
  'Biznesu',
  'Burzy',
  'Chaosu',
  'Ciemności',
  'Cieni',
  'Dominatora',
  'Górskiego',
  'Gromu',
  'Kamilka',
  'Kazika',
  'Koszmaru',
  'Krwi',
  'Krzysztofa',
  'Kubicy',
  'Kustosz',
  'Matiego',
  'Nocy',
  'Otchłani',
  'Piekła',
  'Podróżnika',
  'Popiołów',
  'Pożogi',
  'Radzimirskiego',
  'Śmierci',
  'Śmierdziwilka',
  'Światła',
  'Wieczności',
  'Zagłady',
  'Zarazy',
  'Zniszczenia',
] as const;

/**
 * Generates a random boss name from prefix and suffix arrays
 */
export function generateBossName(): string {
  const prefix = randomElement(BOSS_NAME_PREFIXES);
  const suffix = randomElement(BOSS_NAME_SUFFIXES);
  return `${prefix} ${suffix}`;
}
